/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-08-14 09:50:23
 */
import React, { useState, useEffect} from "react";
import { Progress, Table, message, Modal, Button } from 'antd';
import type { TableColumnsType } from 'antd';
import { useParams, useNavigate } from "react-router-dom";
import ProcessModal from '../payment/components/process-modal';
import DeleteModal from '../../personal-center/components/delete-modal';
import OrderCancel from '../components/order-cancel';
import TipsModal from '../payment/components/tips-modal';
import ApplyModal from "../my-invoice/components/apply-modal";
import ViewModal from "../my-invoice/components/view-modal";
import ReceiptModal from "../my-invoice/components/receipt-modal";
import ActivationInfo from '../components/activation-info';

import { getOrderById, processDetail, deleteOrderList, confirmReceipt } from '@/api/personal-center';
import { useCountdown,timeToSeconds,secondsToTime} from '@/utils/index';
import { merchBill } from './config';
import { getBill } from '@/api/my-invoice';
import {getBuyWay} from '@/utils'
import './index.scss';
interface IProps {
  restTime: string,
  setIsTimeOut: any
}
export const RestTime: React.FC<IProps> = (props) => {
  const [restTime,setRestTime] = useState<any>(null); // 剩余支付时间
  const { timeLeft,reset } = useCountdown(timeToSeconds(props.restTime)); 
  useEffect(() => { 
    setRestTime(timeLeft);
    if(timeLeft <= 0) {
      props.setIsTimeOut(true);
    }
  },[timeLeft,reset])
  useEffect(() => {
    const newTime: any = timeToSeconds(props.restTime??'00:00:00');
    reset(newTime);
}, [props.restTime]);
  return (
    <mark>剩余支付时间 {restTime?secondsToTime(restTime):'00:00:00'}</mark>
  );
}
export interface DataType {
  key: React.Key;
  id: number,
  productName: string;
  productPrice: string;
  productQuantity: number;
  subtotal: string;
  pmsFiles: any;
  productSn: string;
  models:any
}
const OrderDetail: React.FC = () => {
  const param = useParams();
  const navigate = useNavigate();
  const [orderInfo, setOrderInfo] = useState<any>({});
  const [cancelFlag, setCancelFlag] = useState(false); // 取消订单
  const [sureFlag, setSureFlag] = useState(false); // 确认收货
  const [orderDeleteModal, setOrderDeleteModal] = useState(false);
  const [merchBillList, setMerchBillList] = useState<DataType[]>([]);
  const [payReviewList, setPayReviewList] = useState<any>([]);
  const [timeList, setTimeList] = useState<any>([]); // 时间节点
  const [processNum, setProcessNum] = useState(0); // 进度
  const [isRefresh, setIsRefresh] = useState(false); // 更新列表
  const [showProcessModal, setShowProcessModal] = useState(false); // 对公支付弹窗
  const [isTimeOut, setIsTimeOut] = useState(false); // 支付超时弹窗提示
  const [sizeLength, setSizeLength] = useState(930); // 进度条长度
  const [processTitle, setProcessTitle] = useState('待付款'); //流转节点状态
  const [showApplyModal, setShowApplyModal] = useState(false); // 申请开票
  const [showViewModal, setShowViewModal] = useState(false); // 查看发票进度
  const [showReceiptModal, setShowReceiptModal] = useState(false); // 查看发票
  const [isChange,setIsChange] = useState<number>(1);// 修改申请，掉接口不同，做不同的标记1:第一次，2：修改
  const merchBillColumns: TableColumnsType<DataType> = [
    {
      title: '商品',
      dataIndex: 'productName',
      width: 460,
      render: (text: string, record: DataType) => (
        <div
          className="name-show"
          title={text + ' ' + (record.models.find((ele: any) => ele?.type === 1))?.models +' '+ (record.models.find((ele:any)=>ele?.feeType==='2')?getBuyWay((record.models.find((ele:any)=>ele?.type===1))?.subscribe[0]?.unit):'')}
          onClick={() => window.open(`/detail?productSn=${record.productSn}`)}>
          <img src={record.pmsFiles[0]?.url} alt="" />
          {text}<span>
          {
            record.models.length > 0 &&
            <>
            {(record.models.find((ele:any)=>ele?.type===1))?.models} {record.models.find((ele:any)=>ele?.feeType==='2')&&getBuyWay((record.models.find((ele:any)=>ele?.type===1))?.subscribe[0]?.unit)}
            </>
          }
          </span>
        </div>
      ),
    },
    {
      title: '单价',
      dataIndex: 'productPrice',
      render:(text: string) => (
        <span>¥{text}</span>
      )
    },
    {
      title: '数量',
      dataIndex: 'productQuantity',
    },
    {
      title: '小计',
      dataIndex: 'subtotal',
      render: (text: string, record: DataType) => <span className="subtotal-price">¥{(Number(record.productPrice) * record.productQuantity).toFixed(2)}</span>,
    },
  ];
  useEffect(() => {
    orderDetailFunc();
  },[param.id])
  useEffect(() => {
    if(isRefresh) {
      orderDetailFunc();
    }
  },[isRefresh])
  // 监听浏览器tab切换，调取接口，获取最新的定时器时间
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        orderDetailFunc();
        // 执行你的代码，例如发送数据到服务器
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  // 订单详情
  const orderDetailFunc = () => {
    getOrderById({id: param.id}).then((gRes:any) => {
      if(gRes.success) {
        const getObj = gRes.obj;
        // orderNodeDetail(getObj.payType);
        setOrderInfo(getObj);
        setMerchBillList(getObj.productList);
        let timeArr = [getObj.createTime,getObj.paymentTime,getObj.deliverTime,getObj.deliverTime,getObj.receiveTime];
        let newArray = [...merchBill];
        if(getObj.payStatus === 3) {
          newArray = [
            ...merchBill.slice(0, 1), // 取第一个元素之前的部分（即第一个元素本身，因为是从0开始索引的）
          {
            name: '付款审核',
            status: 6,
            title: '待审核'
          }, // 插入新对象
            ...merchBill.slice(1) // 取第一个元素之后的所有部分
          ];
          timeArr = [...timeArr.slice(0,1),getObj.auditTime,...timeArr.slice(1)];
        }
        if(getObj.status === 4 && getObj.payType !== 4) { // 订单取消
          newArray=[ 
            {
              name: '提交订单',
              status: 0,
              title: '待付款'
            },
            {
              name: '订单取消',
              status: 4,
              title: '已取消'
            },
          ]
          timeArr=[getObj.createTime,getObj.cancelTime]
          setSizeLength(310);
        }
        if(getObj.payType === 4 && getObj.status === 4) { // 对公转账取消
          newArray=[
            {
              name: '提交订单',
              status: 0,
              title: '待付款'
            },
            {
              name: '付款审核',
              status: 6,
              title: '待审核'
            },
            {
              name: '订单取消',
              status: 4,
              title: '已取消'
            },
          ]
          timeArr=[getObj.createTime,getObj.auditTime,getObj.cancelTime]
          setSizeLength(465);
        }
        let getIndex = 0;
        timeArr.forEach((nData:string,index:number) => {
          if(nData) {
            setProcessNum(((index+1)*100)/timeArr.length);
            getIndex = index;
            return
          }
        })
        newArray.forEach((nEle:any,index:number) => {
          if(index === getIndex) {
            setProcessTitle(nEle.title)
          }
        })
        setTimeList(timeArr);
        setPayReviewList(newArray);
      }
    })
  }

  // 立即支付
  const nowPayFunc = () => {
    navigate(`/user/payment?orderId=${param.id}`);
  }
  // 取消订单
  const cancelOrderDialog = () => {
    setCancelFlag(true);
    setIsRefresh(false);
  }
  // 删除订单弹窗
  const orderDeleteDialog = () => {
    setOrderDeleteModal(true);
  }
  // 删除订单
  const orderDeleteFunc = () => {
    if(param.id && param.id !== '') {
      deleteOrderList(param.id).then((dRes:any) => {
        if(dRes.success) {
          message.success('删除成功！');
          setOrderDeleteModal(false);
          navigate('/user/orderList');
        }else {
          message.error(dRes.message);
        }
      }) 
    }
  }
  // 确认收货弹窗
  const confirmDialog = () => {
    setSureFlag(true);
  }
  // 确认收货
  const confirmReceiptFunc = () => {
    if(param.id && param.id !== '') {
      confirmReceipt(param.id).then((cRes:any) => {
        if(cRes.success) {
          orderDetailFunc();
        }else {
          message.error(cRes.message);
        }
      })
      setSureFlag(false);
    }
  }
  // 申请售后
  const applyServiceFunc = () => {
    if(orderInfo.applyStatus === 1) {
      message.warning('已全部退款，请勿重复操作，如有疑问请联系客服');
    }else {
      navigate(`/user/as/${orderInfo.id}`);
    }
  }

   // 查看发票
   const handleViewReceipt = () => {
    // setOrderId(id);
    // setShowReceiptModal(true);
    getBill(orderInfo.id).then((res: any) => {
      if (res.success) {
        // setReceiptUrl(res.obj?.showUrl);
       window.open(res.obj?.showUrl, '_blank');
        
      } else {
        message.error(res.message);
      }
    })
  
  }
  return (
    <div className="order-detail-main">
      <div className="order-head">
        订单详情
        <div className="after-sales">
          {
            (orderInfo.status === 0 && orderInfo.payType !== 4) &&
            <>
              <span className="light" onClick={()=>nowPayFunc()}>立即支付</span>
              <span onClick={()=>cancelOrderDialog()}>取消订单</span>
            </>
          }
          {
            orderInfo.status === 4 &&
            <span onClick={()=>orderDeleteDialog()}>删除订单</span>
          }
          {
            (orderInfo.payType === 4 && (orderInfo.payStatus === 3 || orderInfo.payStatus === 4)) &&
            <>
              <span className="light" onClick={()=> setShowProcessModal(true)}>立即支付</span>
              <span onClick={()=>cancelOrderDialog()}>取消订单</span>
            </>
          }
          {
            (orderInfo.status === 3 || orderInfo.status === 2 || orderInfo.status === 1) &&
            <>
            {
              orderInfo.status === 2 && 
              <span className="light" onClick={()=> confirmDialog()}>确认收货</span>
            }
            <span onClick={()=>applyServiceFunc()}>申请售后</span>
            {
              (orderInfo.billStatus === 1 || orderInfo.billStatus === 4) &&
              <span onClick={()=>setShowApplyModal(true)}>申请开票</span>
            }
            {
              orderInfo.billStatus === 2 &&
              <span onClick={()=>setShowViewModal(true)}>查看发票</span>
            }  
            {
              orderInfo.billStatus === 3 &&
              <span onClick={()=>handleViewReceipt()}>查看发票</span> 
            }  
            </>
          }
        </div>
      </div>
      <div className="order-detail-content">
        <div className="pay-time">订单号：{orderInfo.orderNo}
          {
            orderInfo.restTime &&
            <RestTime restTime={orderInfo.restTime} setIsTimeOut={setIsTimeOut} />
          }
        </div>
        <h1>{processTitle}</h1>
        <div className="pay-review-process">
          {
            payReviewList.map((pData:any,index:number) => (
              <span key={index} style={{width: sizeLength/payReviewList.length}}>{pData.name}</span>
            ))
          }
        </div>
        <Progress 
          percent={processNum} 
          showInfo={false} 
          size={[sizeLength,6]}
        />
        <div className="pay-review-process">
          {/* {
            timeList.map((pData:any,index:number) => ( */}
              <div className="process-time" style={{width: sizeLength/timeList.length}}><span>{timeList[0]}</span></div>
            {/* ))
          } */}
        </div>
        {
          Object.keys(orderInfo?.activation ?? {}).length > 0 && <>
           <div className="line"></div>
            <ActivationInfo info={orderInfo} searchOrder={orderDetailFunc}/>
          </>
        }
        {
          orderInfo.logisticVO?.routes?.length > 0 &&
          <>
            <div className="line"></div>
            <h1>订单处理信息
              {/* SDK商品已激活，但订单是 待收货 @TODO*/}
              {
                orderInfo?.activation?.status === 1 && orderInfo.status === 2 && orderInfo.productList?.[0]?.productType===3 &&
                <span style={{marginLeft:'10px'}} className="timeout-info">购买15天后自动确认收货，请及时确认订单信息</span>
              }
              {
                orderInfo.logisticVO?.name &&
                <>
                  <span className="track-number">（物流单号：{orderInfo.logisticVO?.name}&nbsp;&nbsp;{orderInfo.logisticVO?.mailNo}）</span>
                  {
                    (orderInfo.routeStatus === 2 && orderInfo.status !== 3) &&
                    <span className="timeout-info">订单签收后{orderInfo.autoReceiveDay??'15'}天自动确认收货，请及时确认订单信息</span>
                  }
                </>
              }
              
            </h1>
          </>
        }
        {
          orderInfo.logisticVO?.routes?.length > 0 &&
          <ul>
            {
              orderInfo.logisticVO.routes.map((aData:any,index:number) => (
                <li key={index}>
                  <i></i>
                  <span className="order-time">{aData.time}</span>
                  <div className="order-dynamics">
                    <span>{aData.status}</span>
                    {aData.remark}
                  </div>
                </li>
              ))
            } 
          </ul>
        }
        <div className="line"></div>
        <h1>收货信息</h1>
        <div className="receipt-info">
          <div className="receipt-detail">
            <div className="receipt-list"><span>收货人：</span><span>{orderInfo.receiver?.name}</span></div>
            <div className="receipt-list"><span>联系电话：</span><span>{orderInfo.receiver?.tel}</span></div>
            <div className="receipt-list"><span>收货地址：</span><span title={orderInfo.receiver?.province+' '+orderInfo.receiver?.city+' '+orderInfo.receiver?.region+' '+orderInfo.receiver?.detailAddress}>{orderInfo.receiver?.province} {orderInfo.receiver?.city} {orderInfo.receiver?.region} {orderInfo.receiver?.detailAddress}</span></div>
          </div>
          {
            orderInfo.billBase &&
            <div className="receipt-detail">
              <div className="receipt-list"><span>发票类型：</span><span>{orderInfo.billBase.type===3?' 数电专用发票':'数电普通发票'}</span></div>
              <div className="receipt-list"><span>发票抬头：</span><span>{orderInfo.billBase.header}</span></div>
              {
                orderInfo.billBase.type !== 1 &&
                <div className="receipt-list"><span>纳税人识别号：</span><span>{orderInfo.billBase.code}</span></div>
              }
            </div>
          }
          
        </div>
        <div className="line"></div>
        <h1>商品清单</h1>
        <Table<DataType> 
          columns={merchBillColumns} 
          dataSource={merchBillList} 
          pagination={false} 
        />
      </div>
      <div className="order-sum-bottom">
        <div className="sum-detail">
          <div className="sum-list"><span>商品总价：</span><span>￥{orderInfo.totalAmount}</span></div>
          <div className="sum-list"><span>优惠券抵扣：</span><span>-￥{orderInfo.couponAmount}</span></div>
          <div className="sum-list"><span>运费：</span><span>￥{orderInfo.freightAmount??0}</span></div>
          <div className="sum-total"><span>实付款：</span><span>￥{orderInfo.payAmount}</span></div>
        </div>
      </div>
      <OrderCancel cancelFlag={cancelFlag} setCancelFlag={setCancelFlag} orderId={param.id??''} setIsRefresh={setIsRefresh} cancelType={0} />
      <DeleteModal
        showDeleteModal={orderDeleteModal}
        setShowDeleteModal={setOrderDeleteModal}
        handleDelete={orderDeleteFunc}
        title='删除提醒'
        content='删除后不可恢复，请确认是否删除？'
        okText='是'
        cancelText='否'
      />
      <Modal
        title="确认收货"
        open={sureFlag}
        onCancel={()=>setSureFlag(false)}
        className="confirm-dialog-main"
        footer={false}
        width={450}
      >
        <p>请您确认是否收到货物？</p>
        <div className="dialog-bottom">
          <Button className="submit-info" onClick={()=>confirmReceiptFunc()}>是</Button>
          <Button onClick={()=>setSureFlag(false)}>否</Button>
        </div>
      </Modal>
      <TipsModal
        isTimeOut={isTimeOut}
        setIsTimeOut={setIsTimeOut}
        title='订单支付超时，请重新下单支付'
        type='timeOut'
        btnText="确定"
      />
      <ProcessModal
        setShowProcessModal={setShowProcessModal}
        showProcessModal={showProcessModal}
        orderData={orderInfo || {} as any}
        type={orderInfo?.payStatus===4?'order':'close'}
      />
      <ApplyModal
        showApplyModal={showApplyModal}
        setShowApplyModal={setShowApplyModal}
        orderId={orderInfo.id}
        id={orderInfo.billItemId}
        billId={orderInfo.billId}
        isChange={isChange}
      />
      <ViewModal
        showViewModal={showViewModal}
        setShowViewModal={setShowViewModal}
        setShowApplyModal={setShowApplyModal}
        orderId={orderInfo.id}
        id={orderInfo.billItemId}
        setIsChange={ setIsChange}
        />
      <ReceiptModal
        showReceiptModal={showReceiptModal}
        orderId={orderInfo.id}
        setShowReceiptModal={setShowReceiptModal}
      />
    </div>
  )
}

export default OrderDetail;